pez.module('hero', function($, $el) {
    var isRendered = false;
    var $content = $el.find('.hero-content');
    var $cascades = $el.find('.cascade').css('opacity', 0);
    var cascadeInterval = 300;
    var $curtain = $el.find('.hero-curtain');
    //var $next = $el.find('.js-next-section');
    var $win = $(window);
    var max = 1;

    function resize() {
        var h = $win.height();
        $el.css('height', h);
    }

    function scroll() {
        var h = $el.outerHeight() + $el.offset().top;
        var y = $win.scrollTop();
        var p = h === 0 ? 1 : Math.min(1, y / h);
        var opac = max * p;
        $curtain.css('opacity', opac);
        //$next.css('opacity', 1 - opac);
    }

    function forceRender() {
        $content.animate({ opacity: 1 });

        $cascades.each(function(i) {
            var $item = $(this);
            setTimeout(function() {
                $item.animate({ opacity: 1 });
            }, (i + 1) * cascadeInterval)
        });
    }

    function render() {
        if(isRendered) return;
        isRendered = true;
        $el.animate({ opacity: 1 });
        setTimeout(forceRender, 500);
    }

    var src = $el.data().src;
    var img = new Image();
    img.onload = function() {
        render();
    };

    setTimeout(render, 2500);
    if(src) img.src = src;

    resize();
    scroll();
    $win.scroll(scroll);
    $win.resize(resize);
});
